import { z } from "zod";

import { createPaginatedResponseSchema } from "../api/pagination";

import { type UserProfilePreview, UserProfilePreviewSchema } from "./preview";

import { type SessionContext } from "@/context/auth/AuthContext";

export enum UserRestrictionType {
  BLOCKED = "BLOCKED",
}

export type CreateUserRestriction = {
  target: string;
  type: UserRestrictionType;
};

export type RemoveUserRestriction = {
  target: string;
  type: UserRestrictionType;
};

export type Restriction = {
  id: string;
  type: UserRestrictionType;
};

export type UserRestriction = {
  restriction: Restriction;
  profile: UserProfilePreview;
};

export type UserRestrictionCheckResponse = {
  isRestricted: boolean;
};

export const RestrictionSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(UserRestrictionType),
});

export const UserRestrictionSchema = z.object({
  restriction: RestrictionSchema,
  profile: UserProfilePreviewSchema,
});

export const RestrictionResponseSchema = createPaginatedResponseSchema(
  UserRestrictionSchema,
);
export interface WithSessionHandlingProps {
  session: SessionContext["session"];
}
